/**
 * Satisfaction score bands (Client / Company Satisfaction). Drives the progress
 * bar `color` and the rating chip (`UIChip` Base Chips, `appearance="light"`).
 * `chipLabelKey` maps into `dashboard.satisfaction.bands`.
 */
export const SATISFACTION_BANDS = [
  { min: 75, tone: "success", chipColor: "success", chipLabelKey: "good" },
  { min: 50, tone: "warning", chipColor: "warning", chipLabelKey: "needAttention" },
  { min: 0, tone: "error", chipColor: "error", chipLabelKey: "low" },
];

export const getSatisfactionBand = (score) =>
  SATISFACTION_BANDS.find((band) => Number(score) >= band.min) ||
  SATISFACTION_BANDS[SATISFACTION_BANDS.length - 1];
